export function accordionT50() {
    $('.thinkers-cta-section a[data-type="accordion"]').click(function(e) {
        e.preventDefault();
        $('.section-cta-accordion').slideToggle('slow', function() {
            // Check if the accordion is now visible
            if ($('.section-cta-accordion').is(':visible')) {
                // Get the height of the fixed header
                var headerHeight = $('.header').outerHeight(true);

                // Smooth scroll to the accordion, accounting for the header height
                $('html, body').animate({
                    scrollTop: $('.section-cta-accordion').offset().top - headerHeight
                }, 1000); // 1000ms for 1 second
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/accordionT50.js